module.exports = __webpack_public_path__ + "static/media/honesto.0f290567.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/honesto.svg
// module id = 190
// module chunks = 0